var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{attrs:{"type":"file","id":"fileInput"}}),_c('button',{attrs:{"id":"uploadBtn"},on:{"click":_vm.doUpload}},[_vm._v("Upload")]),_c('button',{attrs:{"id":"stopBtn","onclick":"stop()"}},[_vm._v("Stop")]),_c('button',{attrs:{"id":"resumeBtn","onclick":"resume()"}},[_vm._v("resume")]),_c('h2',{attrs:{"id":"status"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }